import { render, staticRenderFns } from "./uploadBtn_V2.vue?vue&type=template&id=6f07933c&scoped=true&"
import script from "./uploadBtn_V2.vue?vue&type=script&lang=js&"
export * from "./uploadBtn_V2.vue?vue&type=script&lang=js&"
import style0 from "./uploadBtn_V2.vue?vue&type=style&index=0&id=6f07933c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07933c",
  null
  
)

component.options.__file = "uploadBtn_V2.vue"
export default component.exports